import React, { useState } from 'react';
import { Button } from '@mui/material';
import { runCleanup } from './utils/cleanupWorkstreamTypes';
import { useWorkspaceContext } from './context/WorkspaceContext';

export const CleanupButton: React.FC = () => {
  const [isRunning, setIsRunning] = useState(false);
  const { workspaceId } = useWorkspaceContext();

  const handleCleanup = async () => {
    if (!workspaceId || isRunning) return;
    
    setIsRunning(true);
    try {
      await runCleanup(workspaceId);
      window.location.reload(); // Refresh to show changes
    } catch (error) {
      console.error('Cleanup failed:', error);
      alert('Failed to clean up duplicate types. Please try again.');
    } finally {
      setIsRunning(false);
    }
  };

  return (
    <Button
      variant="outlined"
      color="warning"
      onClick={handleCleanup}
      disabled={isRunning}
    >
      {isRunning ? 'Cleaning...' : 'Clean Up Duplicate Types'}
    </Button>
  );
};